import { Link } from 'react-router-dom';
import {
  bestFormat,
  displayTitle,
  formatDuration,
  type Recommendation,
} from '@physical-movies/core';
import { useI18n } from '../app/context';
import { PosterImage } from './Poster';
import styles from './recommendation.module.css';

/** One suggestion: what it is, and why it is being suggested. */
export function RecommendationCard({
  recommendation,
  onNavigate,
}: {
  recommendation: Recommendation;
  onNavigate?: () => void;
}) {
  const { t, locale } = useI18n();
  const { movie } = recommendation;

  const title = displayTitle(movie, locale);
  const format = bestFormat(movie);

  const meta = [movie.year ?? null, movie.runtime ? formatDuration(movie.runtime, t) : null]
    .filter(Boolean)
    .join(' · ');

  const reason =
    recommendation.reason === 'never-watched'
      ? t('rec.neverWatched')
      : t('rec.longAgo', { days: recommendation.daysSinceLastWatch ?? 0 });

  const detail =
    recommendation.reason === 'never-watched'
      ? t('rec.ownedFor', { days: recommendation.daysOwned })
      : null;

  return (
    <Link to={`/movie/${movie.id}`} className={styles.card} onClick={onNavigate}>
      <div className={styles.poster}>
        {format && <span className={styles.spine} data-format={format} aria-hidden="true" />}
        <PosterImage posterPath={movie.posterPath} title={title} size="w185" />
      </div>
      <div className={styles.text}>
        <span className={styles.reason}>{reason}</span>
        <span className={styles.title}>{title}</span>
        {meta && <span className={styles.meta}>{meta}</span>}
        {detail && <span className={styles.detail}>{detail}</span>}
      </div>
    </Link>
  );
}
